import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSlideData } from '@context/slide-data';
import { SliderContainer, SectionHeader, TermExplanation, TableStyleThree, TermLabel } from '../styles';
import { getDTIRangeAndColor } from '@utils/creditAnalysisHelpers';
import { STATIC_IMAGES, SHARED_STYLES } from '@constants';
import { DTISlider, DTIStyle, DTILabel } from './styles';
import { generateSlideImageUrl } from '@utils/generateAssetLinks';

export const DTI = () => {
    const slideKey = 'dti';
    const { t } = useTranslation();
    const { desktop, data, mobile } = useSlideData();
    const { details } = data;
    const { monthlyIncome, totalMonthlyPayments, remainingMonthlyIncome, percentage, DTICategory } = details;

    const { DTIRange, backgroundColor } = getDTIRangeAndColor(DTICategory);

    const labels = [0, 35, 49, 100];
    const dtiAsNumber = parseInt(percentage.slice(0, -1));

    if (!labels.includes(dtiAsNumber)) {
        labels.push(dtiAsNumber);
    }

    const labelsWithPercentage = labels
                                    .sort((a, b) => a - b)
                                    .map(option => `${option}%`);

    return (
        <DTIStyle>
            <SectionHeader>{t(`${slideKey}.monthly_income`)}</SectionHeader>
            <TableStyleThree textAlign='left'>
                <thead>
                    <tr>
                        <th>{t(`${slideKey}.monthly_income`)}</th>
                        <th>{t(`${slideKey}.debt_payments`)}</th>
                        <th>{t(`${slideKey}.remaining_income`)}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{monthlyIncome}</td>
                        <td>{totalMonthlyPayments}</td>
                        <td>{remainingMonthlyIncome}</td>
                    </tr>
                </tbody>
            </TableStyleThree>
            <SectionHeader>
                {t(`${slideKey}.dti_ratio`)}
            </SectionHeader>
            <SliderContainer desktop={desktop} mobile={mobile} >
                <DTISlider dti={percentage} desktop={desktop}>
                    <div/>
                    <img src={generateSlideImageUrl(STATIC_IMAGES.sliderThumb)} />
                    <div id='labels'>
                    {
                        labelsWithPercentage.map(option => (
                            <DTILabel
                                desktop={desktop}
                                dti={percentage}
                                value={option}
                                key={option}>
                                    { option !== percentage && <span >|</span>}
                                <span>
                                    <strong>{option}</strong>
                                </span>
                            </DTILabel>
                        ))
                    }
                    </div>
                </DTISlider>
                <TermExplanation
                    height='auto'
                    background={backgroundColor}
                    desktop={desktop}
                    color={SHARED_STYLES.secondaryDarkBlue}>
                        <TermLabel>{t(`${slideKey}.dti_range`)}</TermLabel>
                        <h2>{DTIRange}</h2>
                </TermExplanation>
            </SliderContainer>
            <SectionHeader>{t(`${slideKey}.take_action`)}</SectionHeader>
            <div>{t(`${slideKey}.dti_${DTICategory}`)}</div>
        </DTIStyle>
    );
};

export default DTI;
